import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Chip, Icon } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
import { sdkHooks } from '../sdkHooks';
export const PlayerFriendChip = withGame(function PlayerFriendChip({ gameSuite, playerId }) {
    const status = gameSuite.playerStatuses[playerId] ?? null;
    const inviteMutation = sdkHooks.useSendFriendshipInvite();
    const { data } = sdkHooks.useGetFriendshipInvites({
        direction: 'outgoing',
    });
    const { data: playerInfo } = sdkHooks.useGetUserLazy({ id: playerId });
    const isMe = playerId === gameSuite.playerId;
    const isFriend = playerInfo?.isFriend;
    const inviteSent = data?.some((invite) => invite.otherUser?.id === playerId);
    if (!playerInfo || isMe) {
        return null;
    }
    if (isFriend) {
        return (_jsxs(Chip, { emphasis: "primary", className: "@mode-dense @mode-neutral", children: [_jsx(Icon, { name: "smile", size: 16 }), _jsx("span", { children: "Friend" })] }));
    }
    return (_jsxs(Button, { size: "small", emphasis: "primary", onClick: () => inviteMutation.mutateAsync({ userId: playerId }), disabled: inviteSent, children: [_jsx(Icon, { name: "add_person", size: 16 }), _jsx("span", { children: inviteSent ? 'Sent' : 'Add friend' })] }));
});
//# sourceMappingURL=PlayerFriendChip.js.map